var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgFanoff = function SvgFanoff(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 0C7.64 0 6.57 2.55 7.29 5.47L13 11.16C13.87 11.37 14.81 11.81 15.28 12.73C16.46 15.1 20.03 15 20.03 10.5C20.03 6.92 16.05 6.13 12.35 8.13C12.03 7.73 11.61 7.42 11.13 7.22C11.32 6.29 11.76 5.24 12.75 4.75C15.11 3.57 15 0 10.5 0ZM1.28 2L0 3.27L2.47 5.73C1.22 5.74 0 6.87 0 9.5C0 13.07 3.96 13.85 7.65 11.87C7.97 12.27 8.4 12.59 8.89 12.79C8.69 13.71 8.25 14.75 7.27 15.24C4.91 16.42 5 20 9.5 20C11.8 20 12.94 18.36 12.94 16.21L16.73 20L18 18.72L1.28 2Z",
    fill: "#F5222D"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFanoff, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/fanoff.e6adbfeb.svg";
export { ForwardRef as ReactComponent };